import { useEffect, useState } from 'react'
import { usePostApiV1AccountsConfirmEmailMutation } from '@wellesley/openapi'
import { useFinishSignup } from '../../hooks/useFinishSignup'
import { useSignUpHash } from '../../hooks/useSignUpHash'
import { getServerApiErrorCode, ErrorT } from '@wellesley/error-kit'
import { useDispatch } from 'react-redux'
import { authSlice } from '../../../../authSlice'

export const fixedCacheKey = 'usePostApiV1AccountsConfirmEmailMutation'
export const useSendPassCode = () => {
  const [passCode, setPassCode] = useState<number>()
  const dispatch = useDispatch()
  const { finishSignup } = useFinishSignup()
  const hash = useSignUpHash()

  const [confirmEmail, { isError, error, isLoading }] =
    usePostApiV1AccountsConfirmEmailMutation({
      fixedCacheKey,
    })

  useEffect(() => {
    if (hash && passCode) {
      void (async () => {
        try {
          const res = await confirmEmail({
            codeVerificationParams: { hash, code: passCode },
          }).unwrap()
          await finishSignup(res)
        } catch (error) {
          if (
            getServerApiErrorCode(error as ErrorT) === 'VerificationCodeTooMany'
          ) {
            dispatch(authSlice.actions.resetSignupFields())
            dispatch(authSlice.actions.setSignupStep('signup'))
          }
        }
      })()
    }
  }, [passCode, finishSignup, hash, dispatch])

  return { send: setPassCode, isError, error, isLoading }
}
